mutation SendReminder($input: sendReminderInput!) {
  sendReminder(input: $input)
}

mutation CancelContractAttendeeSignatureRequest(
  $input: CancelContractAttendeeSignatureRequestInput!
) {
  cancelContractAttendeeSignatureRequest(input: $input)
}

mutation CreateSigningProcedure($input: createSigningProcedureInput!) {
  createSigningProcedure(input: $input) {
    success
    skipped
    error
    batch_id
  }
}
